<template>
  <base-modal ref="modal">
    <base-card shadow>
      <div class="sm:tw-flex sm:tw-items-start">
        <div class="tw-mx-auto tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-h-12 tw-w-12 tw-rounded-full tw-bg-red-100 sm:tw-mx-0 sm:tw-h-10 sm:tw-w-10">
          <trash-icon class="tw-h-6 tw-w-6 tw-text-red-600" />
        </div>
        <div class="tw-mt-3 tw-text-center sm:tw-mt-0 sm:tw-ml-4 sm:tw-text-left">
          <h3 class="tw-text-xl tw-font-thin">Decline Invite</h3>
          <div class="tw-mt-2">
            <p class="tw-font-thin tw-text-gray-600">Are you sure you want to decline this invite?</p>
          </div>
        </div>
      </div>
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4">
        <base-button @click="declineInvite" :loading="isDeclining" class="tw-w-full sm:tw-w-auto sm:tw-ml-3" color="red">Confirm</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0" color="red">
          Cancel
        </base-button>
      </div>
    </base-card>
  </base-modal>
</template>

<script>
import TrashIcon from "@/assets/svgs/trash-icon.svg";
import redirect from "@/mixins/redirect";

export default {
  mixins: [redirect],
  components: {
    TrashIcon,
  },
  props: {
    businessId: String,
    businessPlanId: String,
  },
  data() {
    return {
      isDeclining: false,
    };
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    async declineInvite() {
      try {
        this.isDeclining = true;
        await this.$axios.delete(`/businesses/member-invite/${this.$route.params.businessMemberInviteId}`);
        this.$store.commit("memberInvites/clearMemberInvites");
        await this.redirectToHome();
      } finally {
        this.isDeclining = false;
      }
    },
  },
};
</script>
